<template>
  <v-row
    justify="center"
    align="center"
    class="pt-4"
    style="height: 80vh"
    v-if="loading"
  >
    <v-progress-circular
      :size="70"
      color="#5c648b"
      indeterminate
    ></v-progress-circular>
  </v-row>
  <div v-else>
    <v-container class="my-8">
      <MembershipPlans
        :trial="trialPlan"
        :monthly="monthlyPlan"
        :quaterly="quaterlyPlan"
        :annually="yearlyPlan"
        :premiumPlan="premiumPlan"
      />
    </v-container>
    <div
      class="ma-0 my-12"
      style="background: #F7F7F7; border-bottom: 1px solid #B5B5B5;"
    >
      <v-container class="" style="margin-top: 100px;">
        <MembershipTestimonials />
      </v-container>
    </div>
    <v-container>
      <MembershipBenefits
        v-if="$store.state.isMembershipEnabled"
        :plan="monthlyPlan"
      />
      <MembershipBenefits v-else :plan="premiumPlan" />
    </v-container>
    <MembershipPaymentModal />
  </div>
</template>

<script>
  import MembershipBenefits from "../../../components/Membership/MembershipBenefits";
  import MembershipTestimonials from "../../../components/Membership/MembershipTestimonials";
  import MembershipPaymentModal from "../../../components/Membership/MembershipPaymentModal";
  import MembershipPlans from "../../../components/Membership/MembershipPlans";

  import Axios from "../../../api/BaseAxios";
  import { API_CLIENT_URL, ROUTER_URL } from "../../../constants/urls";

  import store from "../../../store";

  import AmplitudeHelper from "../../../amplitude";

  export default {
    name: "MembershipLanding",
    components: {
      MembershipBenefits,
      MembershipPaymentModal,
      MembershipTestimonials,
      MembershipPlans,
    },
    data() {
      return {
        cycle: true,
        slides: ["First", "Second", "Third", "Fourth", "Fifth"],
        loading: true,
        plans: [],
        currency_details: {},
      };
    },
    created() {
      this.getPlans();
      this.$store.state.membership.isRenewMembership = true;
      AmplitudeHelper.registerAmplitudeEvent("view membership pricing page");
      this.$store.state.pageLocation = "membership";
    },
    computed: {
      premiumPlan() {
        let array = this.plans.filter(function(el) {
          return el.name == "Free Trial";
        });

        return array.length > 0 ? array[0] : null;
      },
      trialPlan() {
        let array = this.plans.filter(function(el) {
          return el.type == "Free Trial";
        });

        return array.length > 0 ? array[0] : null;
      },
      yearlyPlan() {
        let array = this.plans.filter(function(el) {
          return el.type == "Annually";
        });

        return array.length > 0 ? array[0] : {};
      },
      monthlyPlan() {
        let array = this.plans.filter(function(el) {
          return el.type == "Monthly";
        });

        return array.length > 0 ? array[0] : {};
      },
      quaterlyPlan() {
        let array = this.plans.filter(function(el) {
          return el.type == "Quarterly";
        });

        return array.length > 0 ? array[0] : {};
      },
      selectedCountry: {
        get() {
          return this.$store.state.mainStore.country;
        },
        set(value) {
          store.dispatch("mainStore/updateCountry", value);
        },
      },
      isMembershipCheckoutEnable: {
        get() {
          return this.$store.state.membership.isMembershipCheckoutEnable;
        },
        set(value) {
          store.dispatch("membership/updateMembershipCheckoutEnable", value);
        },
      },
      membershipDetails: {
        get() {
          return this.$store.state.membership.selectedMembership;
        },
        set(value) {
          this.$store.dispatch("membership/updateSelectedMembership", value);
        },
      },
    },
    watch: {
      selectedCountry() {
        this.getPlans();
      },
    },
    methods: {
      getPlans() {
        const successHandler = (res) => {
          console.log(res);
          this.plans = res.data.data;
          this.currency_details = res.data.currency_details;
          this.isMembershipCheckoutEnable =
            res.data.is_membership_checkout_enable;
          this.loading = false;
        };

        const failureHandler = (res) => {
          console.log(res);
          this.loading = false;
        };

        let params = {};

        Axios.request_POST(
          API_CLIENT_URL.membershipPlan,
          params,
          {},
          successHandler,
          failureHandler
        );
      },
      subscribe(plan) {
        this.$store.state.payment.sessionSeriesId = null;
        this.$store.state.sessionSeriesDetails.data = null;
        this.$store.state.membership.isRenewMembership = false;
        this.membershipDetails = plan;
        this.$router.push({
          name: ROUTER_URL.publicSession.children.membershipCheckout.name,
        });
      },
    },
    mounted() {},
  };
</script>
